<template>
  <div>
    <img src="@/assets/img/c_1.jpg" class="bjImg" alt="">
    <div class="outer_one" :style="'height:'+windowHeight+'px;'">
      <img src="@/assets/img/c_2.png" class="outer_one_1 animate__animated animation_title" alt="">
      <div class="outer_one_2 animate__animated animation_title">用心服务 每一刻都<span>闪耀光彩</span></div>
      <img src="@/assets/img/diqiu.png" class="outer_one_3" alt="">
    </div>
    <div class="boxCont_padd outer_two animate__animated">
      <div class="outer_two_1">“</div>
      <div class="outer_two_2">
        无尽起源是一家领先的互联网技术公司，致力于为全球客户提供高效、创新的互联<br />网解决方案。公司专注于互联网技术的应用与软件开发，涵盖网络建设、软件运营<br />等领域，凭借卓越的技术力量和强大的行业背景，致力于为各行业提供全方位的数<br />字化转型服务。
      </div>
      <div class="outer_two_1 outer_two_3">”</div>
    </div>
    <div class="boxCont_padd outer_tip outer_tip_1 animate__animated">我们的业务</div>
    <div class="boxCont_padd outer_three">
      <div class="outer_three_item elementHover" v-for="(item, index) in yewu" :key="index">
        <img :src="item.img" class="outer_three_item_1" alt="">
        <div class="outer_three_item_2">{{item.title1}}</div>
        <div class="outer_three_item_3">{{item.title2}}</div>
      </div>
    </div>
    <div class="boxCont_padd outer_tip outer_tip_2 animate__animated">我们的特点</div>
    <div class="outer_four">
      <div class="swiper-box outer_four_one animate__animated">
        <div class="swiper-list" :style="{left: swiperLeft, transition: transition}">
          <div class="swiper-item" v-for="(item, index) in swiperList" :key="index"
            :class="{active: swiperIndex+2 == index}" @click="changeSwiperItem(index,item)">
            <img :src="item.image" alt="" class="outer_four_one_img">
            <div class="outer_four_one_one">
              <div class="outer_four_one_one_1">{{item.title}}</div>
              <div class="outer_four_one_one_2">{{item.description}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="boxCont_padd outer_four_two">
        <img src="@/assets/img/d_4.png" class="outer_four_two_1" alt="" @click="changeSwiper(-1)">
        <img src="@/assets/img/d_5.png" class="outer_four_two_1" alt="" @click="changeSwiper(1)">
      </div>
    </div>
    <div class="outer_five">
      <div class="outer_tip outer_tip_3 animate__animated">选择我们的优势</div>
      <div class="outer_five_one settingStyle animate__animated"
        :style="'backgroundImage:url(' + require('@/assets/img/c_10.png') + ')'">
        <div class="outer_five_one_left">
          <div class="outer_five_one_left_1">技术优势</div>
          <div class="outer_five_one_left_2">高水平的技术团队</div>
          <div class="outer_five_one_left_3">团队成员在互联网技术、软件开发、数据分析等领域积累了丰富经验，能根据不同客户需求提供创新性的技术方案。</div>
        </div>
        <img src="@/assets/img/c_9.png" class="outer_five_one_right" alt="">
      </div>
      <div class="outer_five_two">
        <div class="outer_five_two_one animate__animated settingStyle"
          :style="'backgroundImage:url(' + require('@/assets/img/c_11.png') + ')'">
          <div class="outer_five_two_one_1">定制化服务</div>
          <div class="outer_five_two_one_2">提供个性化定制服务</div>
        </div>
        <div class="outer_five_two_two animate__animated">
          <div class="outer_five_two_one_2">安全与稳定性</div>
          <img src="@/assets/img/c_12.png" class="outer_five_two_two_1" alt="">
        </div>
      </div>
    </div>
    <div class="boxCont_padd outer_tip outer_tip_4 animate__animated">公司焦点资讯</div>
    <div class="outer_six" v-if="newsList.length > 0">
      <div class="outer_six_one">
        <div class="outer_six_item elementHover" :id="'outer_six_item'+index"
          :style="'transition-delay:'+ 0.1 * (index+1)+'s'" v-for="(item, index) in newsList" :key="index"
          @click="detailTap(item)">
          <img :src="item.image" class="outer_six_item_img" alt="">
          <div class="outer_six_item_cont">
            <div class="outer_six_item_cont_1">{{item.title}}</div>
            <div class="outer_six_item_cont_2">{{item.description}}</div>
          </div>
        </div>
      </div>
      <div class="boxCont_padd outer_six_two">
        <img src="@/assets/img/d_4.png" @click="leftFn" class="outer_six_two_1" alt="">
        <img src="@/assets/img/d_5.png" @click="rightFn" class="outer_six_two_1" alt="">
      </div>
    </div>
    <commonFoot class="commonFoot animate__animated" type="1"></commonFoot>

    <detailsPopup :visible="visibleCode" :info="visibleInfo" @closepop="closepop"></detailsPopup>
  </div>
</template>

<script>
  // Created by www.xingnuocn.com
  // @title: 公司详情
  // @author: 刘嘉鑫
  import commonFoot from "@/components/commonFoot.vue";
  import detailsPopup from "@/components/details.vue";
  export default {
    components: {
      commonFoot,
      detailsPopup
    },
    data() {
      return {
        windowHeight: 0,
        yewu: [{
          img: require('@/assets/img/c_3.png'),
          title1: "互联网服务",
          title2: "提供一站式互联网技术服务，包括网站建设、云计算解决方案、大数据分析、智能化应用等，帮助客户提升在线服务能力和业务运转效率。",
        }, {
          img: require('@/assets/img/c_4.png'),
          title1: "软件开发",
          title2: "从前端设计到后端架构，涵盖定制化软件开发服务。无尽起源利用先进的开发技术与框架，针对不同行业需求，提供高效且安全的软件产品。",
        }, {
          img: require('@/assets/img/c_5.png'),
          title1: "网络建设",
          title2: "提供企业网络建设服务，包括企业局域网、广域网的规划设计与实施，确保企业网络的稳定性、扩展性及安全性。",
        }, {
          img: require('@/assets/img/c_6.png'),
          title1: "软件运营",
          title2: " 提供软件产品的全面生命周期管理，确保软件在使用过程中能持续稳定地运行，并通过数据分析不断优化功能，提升用户体验。",
        }, {
          img: require('@/assets/img/c_7.png'),
          title1: "AI智能",
          title2: "随着智能手机和AI智能的普及，无尽起源为客户提供定制化的AI智能服务，助力客户拓展移动端市场，提升用户互动与体验。",
        }, {
          img: require('@/assets/img/c_8.png'),
          title1: "企业数字化",
          title2: "提供企业数字化转型咨询服务，帮助企业通过互联网技术、云计算、大数据、人工智能等技术实现业务流程的数字化。",
        }],

        newsList: [],
        aboutIndex: 0,

        advList: [],
        currentIndex: 0,

        tabIndex: 0,
        swiperList: [],
        swiperIndex: 0,
        transition: 'all 0.3s',
        clear: null,

        visibleCode: false,
        visibleInfo: {},
      }
    },
    beforeDestroy() {
      window.addEventListener('resize', res => {
        this.windowHeight = window.innerHeight;
      });
      window.removeEventListener("scroll", this.handleScrollbox, true);
    },
    mounted() {
      window.addEventListener("scroll", this.handleScrollbox, true);
      //  - this.$(".headBox")[0].clientHeight
      this.windowHeight = window.innerHeight;
      window.addEventListener('resize', res => {
        this.windowHeight = window.innerHeight;
      });

      this.getInfo()

    },
    computed: {
      swiperLeft() {
        // console.log(this.swiperIndex)
        return -((this.swiperIndex + 2) * (4 + 0.2) - 3.2) + 'rem'
      }
    },
    methods: {
      // 详情
      getInfo() {
        this.$request({
          url: "/Index/aboutAdv",
        }).then((res) => {
          // console.log("详情", res);
          this.advList = res.about_adv_list;
          const list = [
            ...res.about_adv_list.slice(-2),
            ...res.about_adv_list,
            ...res.about_adv_list.slice(0, 2)
          ]
          this.swiperList = list
        });

        this.$request({
          url: "/Index/newsList",
        }).then((res) => {
          // console.log("详情", res);
          this.newsList = res.news_list;
        });
      },

      changeSwiperItem(index, item) {
        // console.log(this.tabIndex, this.swiperIndex + 2, index)

        if (index > this.swiperIndex + 2) {
          this.changeSwiper(1)
        } else if (index < this.swiperIndex + 2) {
          this.changeSwiper(-1)
        } else {
          return false
        }
      },

      changeSwiper(type) {
        // console.log("typetypetype",type)
        // 防抖
        if (!this.debounce(360)) {
          // console.log("防抖?")
          return
        }
        if (type === 1) {
          // console.log("往右")
          if (this.tabIndex == this.advList.length - 1) {
            this.tabIndex = 0
          } else {
            this.tabIndex++
          }
          this.swiperIndex++
          if (this.swiperIndex == this.swiperList.length - this.advList.length) {
            setTimeout(() => {
              this.transition = 'unset'
              this.swiperIndex = 0
            }, 301);
            setTimeout(() => {
              this.transition = 'all 0.3s'
            }, 360);
          }
        } else {
          // console.log("往左",this.tabIndex,this.advList.length - 1)
          if (this.tabIndex == 0) {
            this.tabIndex = this.advList.length - 1
          } else {
            this.tabIndex--
          }
          this.swiperIndex--
          if (this.swiperIndex == -1) {
            setTimeout(() => {
              this.transition = 'unset'
              this.swiperIndex = this.swiperList.length - this.advList.length - 1
            }, 301);
            setTimeout(() => {
              this.transition = 'all 0.3s'
            }, 360);
          }
        }
      },

      debounce(delay) {
        if (this.clear) {
          return false
        }
        this.clear = setTimeout(() => {
          this.clear = null
        }, delay)
        return true
      },

      detailTap(item) {
        console.log(item)
        this.$request({
          url: "/Index/newsInfo",
          data: {
            id: item.id
          }
        }).then((res) => {
          // console.log("详情", res);
          this.visibleInfo = res.news_info;
          this.visibleCode = true
        });
      },

      closepop(info) {
        console.log(info)
        this.visibleCode = false
        setTimeout(() => {
          this.visibleInfo = {}
        }, 500);
      },

      leftFn() {
        this.aboutIndex = this.aboutIndex == 0 ? 0 : this.aboutIndex - 1
        const el = document.getElementById('outer_six_item' + this.aboutIndex);
        // console.log("往左", this.aboutIndex, el.getBoundingClientRect().left)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      },
      rightFn() {
        this.aboutIndex = this.aboutIndex >= this.newsList.length - 1 ? this.newsList.length - 1 : this.aboutIndex + 1
        const el = document.getElementById('outer_six_item' + this.aboutIndex);
        // console.log("往右", this.aboutIndex, el.getBoundingClientRect().left)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      },

      /**
       * 动画效果
       * 刘嘉鑫
       * 2025-1-15
       */
      handleScrollbox() {
        this.currentScroll = window.pageYOffset; //表示当前滚动的位置

        if (this.currentScroll >= this.$(".outer_one").offset().top) {
          this.$(".outer_two").addClass(" animation_title");
        }
        // 我们的业务
        if (this.currentScroll >= this.$(".outer_one").offset().top + 600) {
          this.$(".outer_tip_1").addClass(" animation_title");
        }
        if (this.currentScroll >= this.$(".outer_two").offset().top) {
          // this.$(".outer_three_item").addClass(" animation_title");
          this.$(".outer_three_item").addClass(" showDiv");
        }
        // 我们的特点
        if (this.currentScroll >= this.$(".outer_two").offset().top + 400) {
          this.$(".outer_tip_2").addClass(" animation_title");
        }
        if (this.currentScroll >= this.$(".outer_two").offset().top + 400) {
          this.$(".outer_four_one").addClass(" animation_title");
        }
        // 选择我们的优势
        if (this.currentScroll >= this.$(".outer_four").offset().top - 200) {
          this.$(".outer_tip_3").addClass(" animation_title");
        }
        if (this.currentScroll >= this.$(".outer_four").offset().top - 100) {
          this.$(".outer_five_one").addClass(" animation_title");
        }
        if (this.currentScroll >= this.$(".outer_four").offset().top) {
          this.$(".outer_five_two_one").addClass(" animation_title");
          this.$(".outer_five_two_two").addClass(" animation_title");
        }
        // 公司焦点资讯
        if (this.currentScroll >= this.$(".outer_five").offset().top + 100) {
          this.$(".outer_tip_4").addClass(" animation_title");
        }
        if (this.currentScroll >= this.$(".outer_five").offset().top + 100) {
          this.$(".outer_six_item").addClass("showDiv");
        }
        //更多精彩 
        if (this.currentScroll >= this.$(".outer_six").offset().top - 300) {
          this.$(".commonFoot").addClass(" animation_title");
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .bjImg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .outer_one {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;

    .outer_one_1 {
      width: 370px;
      height: 73px;
      margin-bottom: 42px;
      padding-top: 300px;
    }

    .outer_one_2 {
      font-weight: 700;
      font-size: 21px;
      color: #FFFFFF;
      letter-spacing: 10px;
      margin-left: 10px;

      span {
        color: #F02874;
      }
    }

    .outer_one_3 {
      position: absolute;
      left: 0;
      right: 0;
      bottom: -1550px;
      width: 100%;
      animation: rotate 500s linear infinite;
      filter: drop-shadow(2px 2px 30px rgba(0, 0, 0, .5));
      border-radius: 50%;
    }

    @keyframes rotate {
      from {
        transform: rotate(0deg);
      }

      to {
        transform: rotate(360deg);
      }
    }
  }

  .boxCont_padd {
    padding-left: 160px;
    padding-right: 160px;
  }

  .outer_two {
    padding: 150px 260px 200px;
    display: flex;
    justify-content: space-between;

    .outer_two_1 {
      font-weight: 700;
      font-size: 90px;
      color: #2A303A;

    }

    .outer_two_2 {
      font-weight: 600;
      font-size: 22px;
      color: #333A47;
      line-height: 44px;
      text-align: center;
      letter-spacing: 6px;
    }
  }

  .outer_tip {
    font-weight: 400;
    font-size: 42px;
    color: #2A303A;
    margin-bottom: 80px;
    opacity: 0;
    letter-spacing: 3px;
  }

  .outer_three {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 40px 40px;
    margin-bottom: 100px;

    .outer_three_item {
      background: linear-gradient(180deg, #EFF7FF 0%, #E6ECF4 100%);
      border-radius: 40px;
      padding: 40px 46px 72px;
      opacity: 0;
      transition: all 0.7s ease-out 0s;
      transform: translate(0px, 40px);

      .outer_three_item_1 {
        width: 40px;
        height: 40px;
        margin-bottom: 40px;
      }

      .outer_three_item_2 {
        font-weight: bold;
        font-size: 26px;
        color: #333A47;
        margin-bottom: 30px;
        letter-spacing: 2px;
      }

      .outer_three_item_3 {
        font-weight: 400;
        font-size: 16px;
        color: #5D6574;
        line-height: 28px;
        letter-spacing: 2px;
      }
    }
  }

  .outer_four {
    margin-bottom: 60px;

    /* .outer_four_one {
      margin-bottom: 40px;

      .outer_four_one_img {
        width: 100%;
        height: 100%;
        border-radius: 40px;
      }

      .outer_four_one_cont {
        margin: 0 20px;
        opacity: 0;
        transition: opacity 1s ease-in-out;

        img {
          width: 1000px;
          height: 460px;
          border-radius: 40px;
        }
      }

      .custom-carousel .el-carousel__item {
        margin-right: 20px;
      }
    } */

    .swiper-box {
      height: 420px;
      position: relative;
      overflow: hidden;
      margin-bottom: 40px;

      .swiper-list {
        display: flex;
        height: 100%;
        overflow-x: auto;
        position: absolute;
        top: 0;
        left: -4rem;
        transition: all 0.3s;

        .swiper-item {
          display: flex;
          align-content: center;
          flex-wrap: wrap;
          width: 4rem;
          height: 100%;
          border-radius: 40px;
          margin-right: 0.2rem;
          opacity: 0.45;
          position: relative;
          cursor: pointer;

          &:last-child {
            margin-right: 0;
          }

          &.active {
            opacity: 1;
          }

          img {
            width: 100%;
            height: 100%;
            border-radius: 40px;
          }

          .outer_four_one_one {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 17px 30px 27px;
            background: linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
            border-radius: 0px 0px 40px 40px;

            .outer_four_one_one_1 {
              font-weight: 700;
              font-size: 26px;
              color: #FFFFFF;
              letter-spacing: 3px;
            }

            .outer_four_one_one_2 {
              font-weight: 500;
              font-size: 16px;
              color: #FFFFFF;
              letter-spacing: 2px;
            }
          }
        }
      }
    }

    .outer_four_two {
      display: flex;
      align-items: center;
      justify-content: center;

      .outer_four_two_1 {
        width: 36px;
        height: 36px;
        margin-left: 20px;
        cursor: pointer;
      }
    }
  }

  .outer_five {
    background: linear-gradient(180deg, #EFF7FF 0%, #E6ECF4 100%);
    padding: 100px 160px;
    margin-bottom: 90px;

    .outer_five_one {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 50px 170px 50px 202px;
      background: rgba(255, 255, 255, .8);
      border-radius: 40px;
      margin-bottom: 40px;
      opacity: 0;

      .outer_five_one_left {
        width: 42%;

        .outer_five_one_left_1 {
          font-weight: 700;
          font-size: 24px;
          color: #0057FE;
          margin-bottom: 23px;
          letter-spacing: 3px;
        }

        .outer_five_one_left_2 {
          font-weight: 700;
          font-size: 28px;
          color: #333A47;
          margin-bottom: 40px;
          letter-spacing: 2px;
        }

        .outer_five_one_left_3 {
          font-weight: 400;
          font-size: 18px;
          color: #5D6574;
          letter-spacing: 2px;
        }
      }

      .outer_five_one_right {
        width: 320px;
        height: 320px;
      }
    }

    .outer_five_two {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .outer_five_two_one {
        padding: 50px 80px 44px;
        width: 51%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        opacity: 0;

        .outer_five_two_one_1 {
          font-weight: 700;
          font-size: 24px;
          color: #FFFFFF;
          letter-spacing: 3px;
        }
      }

      .outer_five_two_one_2 {
        font-weight: bold;
        font-size: 28px;
        color: #FFFFFF;
      }

      .outer_five_two_two {
        background: #0057FE;
        border-radius: 40px;
        width: 26%;
        padding: 26px 80px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        opacity: 0;

        .outer_five_two_two_1 {
          width: 62px;
          height: 76px;
        }
      }
    }
  }

  .outer_six {
    padding-bottom: 60px;

    .outer_six_one {
      display: flex;
      align-items: center;
      margin-bottom: 40px;
      overflow-x: auto;
      overflow-y: hidden;

      .outer_six_item {
        position: relative;
        margin-right: 40px;
        transition: all 0.7s ease-out 0s;
        transform: translate(0px, 70px);
        opacity: 0;

        .outer_six_item_img {
          width: 440px;
          height: 220px;
          border-radius: 28px;
        }

        .outer_six_item_cont {
          position: relative;
          padding: 30px 20px;

          .outer_six_item_cont_1 {
            font-weight: bold;
            font-size: 22px;
            color: #333A47;
            margin-bottom: 6px;
            letter-spacing: 2px;
          }

          .outer_six_item_cont_2 {
            font-weight: 400;
            font-size: 16px;
            color: #5D6574;
            letter-spacing: 2px;
          }
        }

      }

      .outer_six_item:first-child {
        margin-left: 160px;
      }

      .outer_six_item:last-child {
        margin-right: 160px;
      }
    }

    .outer_six_two {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .outer_six_two_1 {
        width: 36px;
        height: 36px;
        margin-left: 20px;
        cursor: pointer;
      }
    }
  }

  .commonFoot {
    opacity: 0;
  }
</style>